/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useMemo} from 'react';
import {useGenericModelHooks, useShouldEditField} from "../../../Hooks/GenericModelHooks";
import * as renderers from "../RecordRenderers";

export const CompactModelViewerRenderer = props => {
    const {
        getFieldDefs,
        updateField,
        updateFields,
        sortFieldDefs,
    } = useGenericModelHooks(props);

    const shouldEditField = useShouldEditField();
    const editMode = shouldEditField(props);

    const {
        FieldDefinitionGroups,
        SkipBorder,
        RootData,
        Data,
        Validation,
        OnValidationUpdate,
        CustomData,
        IsNewModel,
        DefaultSelectedFieldDefKey,
        FieldGroup
    } = props;

    const sortedFields = useMemo(
        () => sortFieldDefs(FieldGroup?.value),
        [sortFieldDefs, FieldGroup?.value]
    );

    return <div className="sb-compact-viewer">
        {
            sortedFields.map(fieldDef => {
                const FieldDefRenderer = renderers?.[fieldDef?.renderer ?? 'StandardModelViewerRecordRenderer'];

                if (typeof FieldDefRenderer !== 'function') {
                    console.log('invalid fieldDefRenderer', FieldDefRenderer);
                    return <b>{fieldDef?.renderer}</b>;
                }

                return <FieldDefRenderer
                    key={fieldDef?.key}
                    EditMode={editMode}
                    FieldDefinitionGroups={FieldDefinitionGroups}
                    FieldDef={fieldDef}
                    RootData={RootData}
                    Data={Data}
                    Validation={Validation?.[fieldDef?.key]}
                    UpdateField={updateField}
                    UpdateFields={updateFields}
                    GetFieldDefs={getFieldDefs}
                    OnValidationUpdate={OnValidationUpdate}
                    SkipBorder={SkipBorder}
                    CustomData={CustomData}
                    IsNewModel={IsNewModel}
                    DefaultSelectedFieldDefKey={DefaultSelectedFieldDefKey}
                />;
            })
        }
    </div>;
};
